"use strict";
exports.__esModule = true;
exports.AssignmentCalendarItem_SubmissionType = exports.AssignmentCalendarItem_ProgressState = exports.protobufPackage = void 0;
/* eslint-disable */
exports.protobufPackage = 'coursera.proto.degreehome.v1beta1';
/** Assignment progress state. */
exports.AssignmentCalendarItem_ProgressState = {
    /** PROGRESS_STATE_INVALID - Default progress state, if not set. Should never happen. */
    PROGRESS_STATE_INVALID: 'PROGRESS_STATE_INVALID',
    /** PROGRESS_STATE_NOT_SUBMITTED - If the assignment is not submitted by the student. */
    PROGRESS_STATE_NOT_SUBMITTED: 'PROGRESS_STATE_NOT_SUBMITTED',
    /** PROGRESS_STATE_SUBMITTED - If the assignment is not submitted by the student, but not graded. */
    PROGRESS_STATE_SUBMITTED: 'PROGRESS_STATE_SUBMITTED',
    /** PROGRESS_STATE_FAILED - If the assignment is graded and not passed. */
    PROGRESS_STATE_FAILED: 'PROGRESS_STATE_FAILED',
    /** PROGRESS_STATE_PASSED - If the assignment is graded and passed. */
    PROGRESS_STATE_PASSED: 'PROGRESS_STATE_PASSED',
    /** PROGRESS_STATE_OVERDUE - If the assignment is not submitted and overdue. */
    PROGRESS_STATE_OVERDUE: 'PROGRESS_STATE_OVERDUE',
    UNRECOGNIZED: 'UNRECOGNIZED'
};
/** Submission type configured for the assignment. */
exports.AssignmentCalendarItem_SubmissionType = {
    /** SUBMISSION_TYPE_INVALID - This value should not be expected. An assignment should always have a submission type. */
    SUBMISSION_TYPE_INVALID: 'SUBMISSION_TYPE_INVALID',
    /** SUBMISSION_TYPE_INDIVIDUAL - The assignment is configured to be submitted by individual learners. */
    SUBMISSION_TYPE_INDIVIDUAL: 'SUBMISSION_TYPE_INDIVIDUAL',
    /** SUBMISSION_TYPE_TEAM - The assignment is configured to be submitted by teams. */
    SUBMISSION_TYPE_TEAM: 'SUBMISSION_TYPE_TEAM',
    /** SUBMISSION_TYPE_OTHER - The assignment has a submission type that doesn't belong to any of the common categories. */
    SUBMISSION_TYPE_OTHER: 'SUBMISSION_TYPE_OTHER',
    UNRECOGNIZED: 'UNRECOGNIZED'
};
